module.exports = __webpack_public_path__ + "img/f5.c523d341.jpg";